import merge from 'deepmerge';
import settingsGlobal from './settings.json';
import settingsLocal from './settings.local.json';
export var settings = merge(settingsGlobal, settingsLocal);
export default settings;
